export default "__VITE_ASSET__DTyvYNQv__"